import { z } from "zod";

export const campaignSettingsUpdateSchema = z
  .object({
    name: z.string().trim().min(1).max(128).optional(),
    // Match the persisted numeric(12, 2) before issuing a remote write.
    dailyBudget: z.number().finite().positive().max(9999999999.99).multipleOf(0.01).optional(),
    endDate: z.string().date().nullable().optional(),
    portfolioId: z.string().uuid().nullable().optional(),
  })
  .strict()
  .refine((input) => Object.values(input).some((value) => value !== undefined), {
    message: "At least one setting is required",
  });
export type CampaignSettingsUpdate = z.infer<typeof campaignSettingsUpdateSchema>;
